var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    transitOptions
  } = options;

__p+='\n\n<div class="row">\n  <div class="col-md-8 col-xxs-12 transit-info">\n  ';
 transitOptions.forEach(function(transit) { 
__p+='\n    <div class="transit-wrap">\n      <div class="transit-inner">\n        <h4 class="transit-station-name">'+
((__t=( transit.name ))==null?'':__t)+
'</h4>\n        <ul class="transit-lines">\n          ';
 let transitLines = transit.lines.filter(n => n) 
__p+='\n          ';
 transitLines.forEach(function(line) { 
__p+='\n            <li class="'+
((__t=( line.class ))==null?'':__t)+
'"><p>'+
((__t=( line.name ))==null?'':__t)+
'</p></li>\n          ';
 }); 
__p+='\n        </ul>\n      </div>\n      ';
 if (transit.time_required === 'Within 5 minutes of walking distance') { 
__p+='\n        <p class="meta-info">'+
((__t=( transit.time_required ))==null?'':__t)+
'</p>\n      ';
 } else { 
__p+='\n        <p class="meta-info"><span>'+
((__t=( `${transit.distance} mile${transit.distance !== 1 ? 's' : ''}` ))==null?'':__t)+
'</span><span class="transit-info-dot">.</span><span>'+
((__t=( transit.time_required ))==null?'':__t)+
'</span></p>\n      ';
 } 
__p+='\n    </div>\n  ';
 }); 
__p+='\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/building_transit_options.jst.ejs